import React, { CSSProperties } from "react";
import { GridLoader } from "react-spinners";

type LoadingModalInputProps = {
  showModal: boolean;
};

const LoadingModal: React.FC<LoadingModalInputProps> = ({ showModal }) => {
  if (!showModal) {
    return null;
  }

  // override to ensure the spinner itself has no background
  const spinnerStyle: CSSProperties = {
    backgroundColor: "transparent",
  };

  return (
    <>
      {/* backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50 z-40" />

      {/* spinner container */}
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <GridLoader
          size={40} // adjust as needed
          color="#F47D20" // orange spinner against the dark backdrop
          loading={true}
          cssOverride={spinnerStyle}
        />
      </div>
    </>
  );
};

export default LoadingModal;
